import { useCategories } from "@/hooks/useProducts";

// Imagens de capa por categoria — cada uma com visual completamente único e coerente com o nome.
// Cenários totalmente diferentes: sill, flatlay, lifestyle, still-life, etc.
const CATEGORY_COVERS: Record<string, string> = {
  "Vasos & Plantas":
    "https://readdy.ai/api/search-image?query=A%20single%20tall%20handmade%20terracotta%20vase%20holding%20a%20dried%20pampas%20grass%20stem%20placed%20on%20a%20sun-drenched%20windowsill%20with%20a%20sheer%20white%20linen%20curtain%20blowing%20softly%20behind%20it%2C%20warm%20afternoon%20golden%20hour%20sunlight%20casting%20a%20long%20thin%20shadow%20across%20a%20pale%20plaster%20wall%2C%20clean%20minimalist%20Brazilian%20interior%2C%20light%20ivory%20and%20warm%20sand%20palette%2C%20sharp%20editorial%20photography%20with%20fine%20grain%20texture%2C%20high%20detail%2C%20no%20people%2C%20no%20text&width=600&height=800&seq=cat-vasos-pt-2026&orientation=portrait&nocache=true",
  "Cerâmica & Louças":
    "https://readdy.ai/api/search-image?query=Close-up%20overhead%20flat-lay%20of%20three%20stacked%20hand-thrown%20rustic%20stoneware%20bowls%20in%20matte%20oatmeal%20glaze%20with%20subtle%20brown%20speckle%2C%20resting%20on%20a%20dark%20aged%20walnut%20wood%20surface%20next%20to%20a%20folded%20ochre%20linen%20napkin%2C%20dramatic%20moody%20low%20side%20lighting%20creating%20deep%20rich%20contrast%2C%20artisanal%20tableware%20photography%2C%20very%20rich%20warm%20brown%20and%20cream%20tones%2C%20sharp%20crisp%20detail%2C%20no%20people&width=600&height=800&seq=cat-ceramica-pt-2026&orientation=portrait&nocache=true",
  "Almofadas & Têxteis":
    "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20thick%20woven%20cotton%20throw%20blankets%20and%20plump%20linen%20cushions%20in%20warm%20mustard%20ochre%2C%20dusty%20rust%20and%20natural%20cream%2C%20folded%20and%20piled%20on%20a%20light%20woven%20rattan%20bench%20beside%20a%20tall%20leafy%20green%20indoor%20plant%20in%20a%20clay%20pot%2C%20bright%20Scandinavian-inspired%20cozy%20Brazilian%20bedroom%20corner%2C%20soft%20diffused%20morning%20natural%20daylight%20from%20a%20window%2C%20detailed%20fabric%20weave%20texture%20visible%2C%20cozy%20tactile%20lifestyle%20photography%2C%20warm%20autumn%20palette%2C%20no%20people&width=600&height=800&seq=cat-texteis-pt-2026&orientation=portrait&nocache=true",
  "Velas & Aromas":
    "https://readdy.ai/api/search-image?query=A%20single%20thick%20pillar%20candle%20with%20a%20burning%20flame%20in%20a%20matte%20black%20ceramic%20holder%20resting%20on%20a%20smooth%20white%20stone%20surface%2C%20a%20small%20dried%20lavender%20sprig%20and%20two%20smooth%20grey%20pebbles%20arranged%20beside%20it%2C%20very%20dark%20moody%20black%20background%20with%20dramatic%20low%20chiaroscuro%20lighting%2C%20intimate%20atmospheric%20spa-like%20still%20life%20photography%2C%20intense%20deep%20contrast%2C%20warm%20amber%20glow%2C%20ultra%20detailed%20realistic%20flame%20light%2C%20no%20people&width=600&height=800&seq=cat-velas-pt-2026&orientation=portrait&nocache=true",
  "Iluminação":
    "https://readdy.ai/api/search-image?query=A%20handmade%20woven%20natural%20rattan%20pendant%20lamp%20hanging%20above%20a%20small%20round%20solid%20oak%20side%20table%20with%20an%20open%20book%20and%20a%20single%20white%20ceramic%20mug%2C%20cozy%20Brazilian%20bedroom%20interior%20at%20golden%20hour%20dusk%2C%20warm%20amber%20pool%20of%20lamplight%20spreading%20across%20a%20cream%20textured%20plaster%20wall%2C%20intimate%20atmospheric%20editorial%20interior%20photography%2C%20rich%20warm%20golden%20and%20shadow%20tones%2C%20ultra%20realistic%20no%20people&width=600&height=800&seq=cat-iluminacao-pt-2026&orientation=portrait&nocache=true",
  "Objetos Decorativos":
    "https://readdy.ai/api/search-image?query=A%20curated%20gallery%20shelf%20arrangement%20of%20three%20small%20artisan%20decorative%20objects%2C%20a%20hand-carved%20dark%20wood%20abstract%20figurine%2C%20a%20miniature%20burnished%20brass%20bowl%20and%20a%20tiny%20textured%20ceramic%20vessel%20with%20dried%20herbs%2C%20displayed%20on%20a%20floating%20white%20oak%20shelf%20against%20a%20warm%20sand-colored%20rough%20plaster%20wall%2C%20soft%20directional%20museum-like%20gallery%20lighting%20from%20one%20side%2C%20refined%20minimalist%20still%20life%20composition%2C%20muted%20natural%20earthy%20tones%2C%20sharp%20photographic%20detail%2C%20no%20people&width=600&height=800&seq=cat-objetos-pt-2026&orientation=portrait&nocache=true",
};

const DEFAULT_COVER =
  "https://readdy.ai/api/search-image?query=Curated%20Brazilian%20artisan%20home%20decor%20objects%20arrangement%20with%20ceramic%20vase%20woven%20basket%20and%20linen%20cushion%20placed%20on%20a%20wooden%20surface%2C%20warm%20natural%20daylight%2C%20earthy%20neutral%20tones%2C%20styled%20editorial%20product%20photography%2C%20realistic%20detail%2C%20no%20people&width=600&height=800&seq=cat-default-pt-2026&orientation=portrait";

interface CategoriesProps {
  activeId: number | null;
  onSelect: (id: number | null, name: string | null) => void;
}

export default function Categories({ activeId, onSelect }: CategoriesProps) {
  const { categories, loading, error } = useCategories();

  const handleClick = (id: number, name: string) => {
    if (activeId === id) {
      onSelect(null, null);
    } else {
      onSelect(id, name);
    }
    requestAnimationFrame(() => {
      const el = document.getElementById("featured");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50 border-b border-background-200/60">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-foreground-950 text-2xl md:text-3xl font-medium">
              Categorias
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              Escolha uma categoria e encontre o que combina com a sua casa
            </p>
          </div>
          <button
            type="button"
            onClick={() => {
              onSelect(null, null);
              requestAnimationFrame(() => {
                const el = document.getElementById("featured");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              });
            }}
            className="hidden md:inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap pb-1 border-b border-foreground-300 hover:border-primary-500"
          >
            Ver todos
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {loading && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 md:gap-5">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="aspect-[3/4] rounded-2xl bg-background-100 animate-pulse"
              />
            ))}
          </div>
        )}

        {!loading && error && (
          <p className="text-sm text-foreground-700 text-center py-6">
            Não foi possível carregar as categorias.
          </p>
        )}

        {!loading && !error && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 md:gap-5">
            {categories.map((cat) => {
              const isActive = activeId === cat.id;
              return (
                <button
                  key={cat.id}
                  type="button"
                  onClick={() => handleClick(cat.id, cat.name)}
                  className="group cursor-pointer text-left"
                  aria-pressed={isActive}
                >
                  <div
                    className={`relative w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-100 transition-all duration-300 ${
                      isActive
                        ? "ring-2 ring-primary-500 ring-offset-2 ring-offset-background-50"
                        : "ring-1 ring-background-200/0 group-hover:ring-2 group-hover:ring-foreground-900/20"
                    }`}
                  >
                    <img
                      src={CATEGORY_COVERS[cat.name] ?? DEFAULT_COVER}
                      alt={cat.name}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent"></div>

                    {isActive && (
                      <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-[11px] font-medium">
                        <i className="ri-check-line"></i>
                        Ativa
                      </span>
                    )}

                    <div className="absolute inset-x-0 bottom-0 p-3 md:p-4 flex items-end justify-between gap-2">
                      <h3 className="font-heading text-background-50 text-sm md:text-base leading-tight">
                        {cat.name}
                      </h3>
                      <span
                        className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:-translate-y-0.5 ${
                          isActive
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-50 text-foreground-950 group-hover:bg-primary-500 group-hover:text-background-50"
                        }`}
                      >
                        <i
                          className={`${
                            isActive ? "ri-close-line" : "ri-arrow-right-up-line"
                          } text-xs`}
                        ></i>
                      </span>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}